import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authService } from '../services/api';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.forgotPassword(email);
      setSuccess(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to send reset email. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: isMobile ? '15px' : '20px',
      }}>
        <div style={{
          background: 'white',
          borderRadius: isMobile ? '20px' : '24px',
          padding: isMobile ? '40px 30px' : '60px',
          maxWidth: '500px',
          width: '100%',
          boxShadow: '0 25px 80px rgba(0, 0, 0, 0.3)',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: isMobile ? '48px' : '64px', marginBottom: '20px' }}>✉️</div>
          <h2 style={{ 
            fontSize: isMobile ? '24px' : '28px', 
            fontWeight: '700', 
            color: '#667eea', 
            marginBottom: '15px',
            margin: 0,
          }}>
            Check Your Email
          </h2>
          <p style={{ 
            fontSize: isMobile ? '15px' : '16px', 
            color: '#5a6c7d', 
            lineHeight: 1.6,
            marginBottom: '30px',
          }}>
            If an account exists with <strong>{email}</strong>, you will receive a password reset link shortly.
          </p>
          <p style={{ 
            fontSize: '14px', 
            color: '#999',
            marginBottom: '30px',
          }}>
            Didn't receive an email? Check your spam folder or try again.
          </p>
          <button
            onClick={() => navigate('/login')}
            style={{
              width: '100%',
              padding: isMobile ? '14px' : '16px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontSize: isMobile ? '15px' : '16px',
              fontWeight: '700',
              cursor: 'pointer',
            }}
          >
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: isMobile ? '15px' : '20px',
    }}>
      <div style={{
        background: 'white',
        borderRadius: isMobile ? '20px' : '24px',
        padding: isMobile ? '40px 30px' : '60px',
        maxWidth: '500px',
        width: '100%',
        boxShadow: '0 25px 80px rgba(0, 0, 0, 0.3)',
      }}>
        <div style={{ 
          marginBottom: isMobile ? '35px' : '40px', 
          textAlign: 'center',
        }}>
          <h3 style={{ 
            fontSize: isMobile ? '28px' : '32px', 
            fontWeight: '700', 
            color: '#667eea', 
            marginBottom: '10px',
            margin: 0,
          }}>
            Forgot Password?
          </h3>
          <p style={{ 
            fontSize: isMobile ? '14px' : '15px', 
            color: '#5a6c7d',
            margin: 0,
            marginTop: '10px',
          }}>
            Enter your email and we'll send you a reset link
          </p>
        </div>

        <form onSubmit={handleSubmit} style={{ 
          display: 'flex', 
          flexDirection: 'column', 
          gap: isMobile ? '20px' : '25px',
        }}>
          {error && (
            <div style={{
              padding: isMobile ? '14px' : '16px',
              borderRadius: '12px',
              fontSize: '14px',
              backgroundColor: '#fee',
              color: '#c00',
              border: '1px solid #fcc',
            }}>
              {error}
            </div>
          )}
          
          <div>
            <label style={{ 
              display: 'block', 
              fontSize: '14px', 
              fontWeight: '600', 
              color: '#667eea', 
              marginBottom: '8px',
            }}>
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
              autoFocus
              style={{
                width: '100%',
                padding: isMobile ? '14px' : '16px',
                border: '2px solid #e0e7ef',
                borderRadius: '12px',
                fontSize: '15px',
                outline: 'none',
                boxSizing: 'border-box',
              }}
            />
          </div>

          <button 
            type="submit" 
            disabled={loading}
            style={{
              width: '100%',
              padding: isMobile ? '16px' : '18px',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              color: 'white',
              border: 'none',
              borderRadius: '12px',
              fontSize: isMobile ? '16px' : '17px',
              fontWeight: '700',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.7 : 1,
            }}
          >
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div style={{ 
          marginTop: isMobile ? '25px' : '30px', 
          textAlign: 'center', 
          fontSize: isMobile ? '14px' : '15px', 
          color: '#5a6c7d',
        }}>
          <p style={{ margin: 0 }}>
            Remember your password?{' '}
            <span 
              onClick={() => navigate('/login')} 
              style={{ color: '#667eea', fontWeight: '700', cursor: 'pointer' }}
            >
              Sign In
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;